import { render, staticRenderFns } from "./CompanyLab.vue?vue&type=template&id=0c47c1e7&scoped=true&"
import script from "./CompanyLab.vue?vue&type=script&lang=js&"
export * from "./CompanyLab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLab.vue?vue&type=style&index=0&id=0c47c1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47c1e7",
  null
  
)

export default component.exports